import React from 'react'
import ChangePassword from 'components/ChangePassword'

import './index.scss'

const UpdatePassword = () => <ChangePassword />

export default UpdatePassword
